import Tabs from "../components/tabs";
import Flickity from "flickity";
// import Headline from "../components/headline-rotate";

export default {
    init() {
    },
    finalize() {
        // var tabs = new Tabs();

        var bannerNode = document.querySelector('.banner--product');
        var bannerImgNode = bannerNode.querySelector('.banner__image img');
        var isPouch = false;
        var isGroup = false;
        if (document.querySelector('.cart.pouch_form')) isPouch = true;
        if (document.querySelector('.cart.grouped_form')) isGroup = true;

        bannerImgNode.addEventListener('load', function() {
            bannerNode.classList.add('loaded');
        });

        jQuery(document).ready(function () {
            // var headline = new Headline(jQuery('.cd-headline'),2500);
            bannerNode.classList.add('loaded');
        });
        
        // quantity control box
		var quantityControlBox = jQuery('.quantity-control-box');
		if (quantityControlBox.length > 0) {
		  var currentQty = Number(jQuery('.cart .quantity input.qty').val());

		  quantityControlBox.find('button').on('click', function(e) {
			  var btnAction = $(this).data('action');
			  switch(btnAction) {
				  case 'add': {
					  currentQty += 1;
				  } break;
				  case 'subtract': {
					  if(currentQty > 1) {
					    currentQty -= 1;
					  }
				  } break;
			  }
			  
			  if(currentQty > 1) {
				  quantityControlBox.find('.subtract-qty').removeClass('disabled');
			  } else {
				  quantityControlBox.find('.subtract-qty').addClass('disabled');
			  }
			  
			  jQuery('.cart .quantity input.qty').attr('value', currentQty);
			  jQuery('.cart .qtyCounter').text(currentQty);
			  
		  });
		  
		  if(currentQty == 1) {
			  quantityControlBox.find('.subtract-qty').addClass('disabled');
		  }
		}

        // make add to cart ajax
        jQuery('.summary .single_add_to_cart_button, .footer .cta .single_add_to_cart_button').click(function(event){

            var $thisbutton = jQuery(this);
            event.preventDefault();

            var summary_button = jQuery('.summary .single_add_to_cart_button');
            var cta_button = jQuery('.footer .cta .single_add_to_cart_button');

            cta_button.addClass('waiting');
            summary_button.addClass('waiting');
            
            var data = {};
            jQuery.each(jQuery('form.cart').serializeArray(), function () {
                data[this.name] = this.value;
            });
            data.product_id = jQuery('.cart input[name=add-to-cart]').val();
            data.quantity = jQuery('.cart input[name=quantity]').val();
            
            // pouches can have multiple quantity. add-to-cart param adds +2 to quantity!
            var $thisbuttonform = $thisbutton.parents('.pouch_form');
            console.log($thisbutton);
            if($thisbuttonform.length > 0 || $thisbutton.hasClass('add_to_cart_pouch')) {
				delete data['add-to-cart'];
			}

            jQuery.ajax({
                type: "POST",
                url: window.ajaxUrl,
                data: data
            })
            .done(function (response) {

                jQuery( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $thisbutton ] );

                if (typeof response.error == "undefined") {

                    if (isGroup || isPouch) {
                        window.location = window.cartUrl;
                        return;
                    }

                    cta_button.removeClass('waiting');
                    summary_button.removeClass('waiting');

                    var summary_html = '<a href="'+window.cartUrl+'" class="added_to_cart wc-forward button button--transparent button--lg" title="View pack">';
                    summary_html += 'View pack';
                    summary_html += '</a>';
                    summary_button.hide();
                    summary_button.parent('.product__add-container').append(summary_html);

                    var cta_html = '<a href="'+window.cartUrl+'" class="added_to_cart_cta wc-forward button" title="View pack">';
                    cta_html += 'View pack';
                    cta_html += '</a>';
                    cta_button.replaceWith(cta_html);

                    if (typeof response.fragments != "undefined") {
                        for (var selector in response.fragments) {
                            jQuery(selector).replaceWith(response.fragments[selector])
                        }
                        jQuery( document.body ).trigger( 'wc_fragments_refreshed' );
                    }
                }
                else {
                    cta_button.removeClass('waiting');
                    summary_button.removeClass('waiting');
                    alert('An error occured while adding to pack. Please refresh the page and try again');
                }

            });
        });

        jQuery('.product__key-fact-heading').click(function() {
            jQuery(this).toggleClass('clicked');
            jQuery(this).siblings('.product__key-fact-text').slideToggle();
        });

    }
};



// WEBPACK FOOTER //
// ./js/routes/single-product.js